import React, { useEffect, useState } from "react";
// css comes in hw CompleteStudentListHW
import ViewEvaluation from "../../evaluation/ViewEvaluation";
import axios from "../../../../../axios";
import PendingSpopup from "../../../onreview/Review_student_list/PendingSpopup";
import { IP } from "../../../../../internalServer";
import AdaptiveEvalutionGraph from "../../CompletedAdaptiveQues/AdaptiveEvalutionGraph";
import { toast } from "react-toastify";
import { Box, Avatar, Chip, Stack, Typography } from "@mui/material";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import CloudOffRoundedIcon from "@mui/icons-material/CloudOffRounded";
import { useNavigate } from "react-router-dom";

/* ---------- Helpers ---------- */

const resolveAvatar = (student_id) => {
  if (student_id?.profile_picture) {
    return IP + student_id.profile_picture.replace(/^\./, "");
  }
  if (student_id?.gender === "M") {
    return student_id?.avatarProfile
      ? `/images/Boys/${student_id.avatarProfile}.webp`
      : "/images/Student_boy_pic.png";
  }
  if (student_id?.gender === "F") {
    return student_id?.avatarProfile
      ? `/images/Girls/${student_id.avatarProfile}.webp`
      : "/images/Student_girl_pic.png";
  }
  return "/images/default image.png";
};

const fallbackAvatar = (student_id) => {
  if (student_id?.gender === "M") {
    return student_id?.avatarProfile
      ? `/images/Boys/${student_id.avatarProfile}.webp`
      : "/images/Student_boy_pic.png";
  }
  if (student_id?.gender === "F") {
    return student_id?.avatarProfile
      ? `/images/Girls/${student_id.avatarProfile}.webp`
      : "/images/Student_girl_pic.png";
  }
  return "/images/default image.png";
};

const formatDate = (a) => {
  const d = new Date(a);
  return `${d.getUTCDate()}/${d.getUTCMonth() + 1}/${d.getUTCFullYear()}`;
};

/* ---------- Status chip ---------- */

const StatusChip = ({ status }) => {
  const s = (status || "").toLowerCase();
  const map = {
    completed: { label: "Completed", bg: "#dcfce7", color: "#15803d" },
    review: { label: "On Review", bg: "#fef3c7", color: "#b45309" },
    pending: { label: "Not Submitted", bg: "#fee2e2", color: "#b91c1c" },
  };
  const cfg = map[s] || {
    label: status || "—",
    bg: "#f3f4f6",
    color: "#6b7280",
  };
  return (
    <Chip
      label={cfg.label}
      size="small"
      sx={{
        bgcolor: cfg.bg,
        color: cfg.color,
        fontWeight: 600,
        fontSize: 11,
        height: 24,
        borderRadius: 1.5,
      }}
    />
  );
};

/* ---------- Main row ---------- */

const CompleteSTable = ({ student, isAutoEval = false, onOfflineClick }) => {
  const [click, setClick] = useState(false);
  const [evaluationData, setEvaluationData] = useState();
  const [studentResultData, setStudentResultData] = useState([]);
  const [chartData, setChartData] = useState();
  const { student_id, assessment_id, submitted_on, status, obtained_marks } =
    student;

  const navigate = useNavigate();
  const [error, setError] = useState(false);

  // ⭐ Offline entry flag
  const isOfflineEntry = student?.is_offline_entry === true;

  useEffect(() => {
    getStudentResponse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getStudentResponse = async () => {
    try {
      let res = await axios.get(
        `/api/v1/assessment/${assessment_id?.id}/studentResult/student/${student_id?.id}/get`,
      );
      if (res) {
        let content = res?.data?.data;
        if (content.assessment.isAdaptive) {
          let questions = res?.data?.data?.results;
          content.results = null;
          let newQuestion = [];
          for (let i = 0; i < content.difficulty_history.length; i++) {
            newQuestion.push(
              questions[content.difficulty_history[i].questionNo],
            );
          }
          content.results = newQuestion;
        }
        let resultes = content.results;
        setStudentResultData(content);
        let qsNoLabels = [];

        if (res?.data?.data?.assessment) {
          const resultArray = resultes.map((curr, index) => {
            const resultObj = {
              questionNumber: `Q${index + 1}`,
            };
            qsNoLabels.push(resultObj.questionNumber);
            return resultObj;
          });
          setChartData(resultArray);
        }
      }
    } catch (error) {
      setError(true);
      console.log(error);
    }
  };

  const getEvoluationData = async () => {
    try {
      if (status === "completed") {
        const res = await axios.get(
          `/api/v1/assessment/${assessment_id?.id}/studentAssessmentStats/student/${student_id?.id}/get`,
        );
        res && setEvaluationData(res.data.data);
      }
      setClick(!click);
    } catch (error) {
      console.log(error);
      setError(true);
      toast.warning(error?.response?.data?.message);
    }
  };

  // ⭐ Name click handler — offline => open offline dialog, else normal flow
  const handleNameClick = () => {
    if (isOfflineEntry) {
      // Don't open leaderboard/popup for offline entries
      if (typeof onOfflineClick === "function") {
        onOfflineClick(student);
      }
      return;
    }
    getEvoluationData();
  };

  const isPending = status?.toLowerCase() === "pending";

  const marksDisplay = isPending
    ? "--"
    : assessment_id?.isAdaptive
      ? studentResultData?.ability
        ? studentResultData.ability.toFixed(2)
        : "--"
      : `${obtained_marks ?? 0} / ${assessment_id?.total_marks ?? 0}`;

  const marksColor = isPending
    ? "#9ca3af"
    : assessment_id?.isAdaptive
      ? "#1d4ed8"
      : obtained_marks && assessment_id?.total_marks
        ? obtained_marks / assessment_id.total_marks >= 0.4
          ? "#15803d"
          : "#b91c1c"
        : "#6b7280";

  return (
    <>
      <tr
        style={{
          borderBottom: "1px solid #f3f4f6",
          transition: "background .15s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.background = "#f9fafb")}
        onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
      >
        {/* Name */}
        <td style={{ textAlign: "left", padding: "12px 16px" }}>
          <Stack
            direction="row"
            alignItems="center"
            spacing={1.25}
            onClick={handleNameClick}
            sx={{ cursor: "pointer" }}
          >
            <Avatar
              src={resolveAvatar(student_id)}
              alt={student_id?.name}
              imgProps={{
                onError: (e) => (e.target.src = fallbackAvatar(student_id)),
              }}
              sx={{
                width: 32,
                height: 32,
                border: "2px solid #eef2ff",
                fontSize: 13,
                fontWeight: 700,
                bgcolor: "#e0e7ff",
                color: "#1d4ed8",
              }}
            >
              {student_id?.name?.charAt(0)?.toUpperCase()}
            </Avatar>
            <Typography
              fontSize={13}
              fontWeight={500}
              color="#1f2937"
              sx={{
                "&:hover": { color: "#1d4ed8" },
                transition: "color .15s",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: 160,
              }}
            >
              {student_id?.name}
            </Typography>

            {/* ⭐ Offline entry chip */}
            {isOfflineEntry && (
              <Chip
                icon={
                  <CloudOffRoundedIcon sx={{ fontSize: "12px !important" }} />
                }
                label="Offline"
                size="small"
                sx={{
                  height: 18,
                  bgcolor: "#ecfdf5",
                  color: "#047857",
                  fontWeight: 700,
                  fontSize: 9,
                  letterSpacing: 0.3,
                  borderRadius: 1,
                  flexShrink: 0,
                  "& .MuiChip-icon": { color: "#047857" },
                }}
              />
            )}
          </Stack>
        </td>

        {/* Roll No. */}
        <td style={{ padding: "12px 16px" }}>
          <Typography fontSize={13} color="#374151">
            {student_id?.roll_number || "—"}
          </Typography>
        </td>

        {/* Class */}
        <td style={{ padding: "12px 16px" }}>
          <Typography fontSize={13} color="#374151">
            {assessment_id?.standard?.name || "—"}
          </Typography>
        </td>

        {/* Division */}
        <td style={{ padding: "12px 16px" }}>
          <Typography fontSize={13} color="#374151">
            {assessment_id?.section?.name || "—"}
          </Typography>
        </td>

        {/* Date submitted */}
        <td style={{ padding: "12px 16px" }}>
          {submitted_on ? (
            <Typography fontSize={13} color="#374151">
              {formatDate(submitted_on)}
            </Typography>
          ) : (
            <Typography fontSize={12} color="#9ca3af" fontStyle="italic">
              Not submitted
            </Typography>
          )}
        </td>

        {/* Marks / Score — auto-eval ho to sparkle */}
        <td style={{ padding: "12px 16px" }}>
          <Stack
            direction="row"
            spacing={0.5}
            alignItems="center"
            justifyContent="center"
          >
            {isAutoEval && !isPending && (
              <AutoAwesomeRoundedIcon sx={{ fontSize: 13, color: "#047857" }} />
            )}
            <Typography fontSize={13} fontWeight={600} color={marksColor}>
              {marksDisplay}
            </Typography>
          </Stack>
        </td>

        {/* Status */}
        <td style={{ padding: "12px 16px" }}>
          <StatusChip status={status} />
        </td>
      </tr>

      {click && status === "completed" && (
        <AdaptiveEvalutionGraph
          assessmentisAdaptive={assessment_id?.isAdaptive}
          setOpenGraphPopup={setClick}
          setPublishResult={setClick}
          evaluationData={evaluationData}
          studentId={student_id?.id}
          studentName={student_id?.name}
          studentResultData={studentResultData}
          chartData={chartData}
          studentData={student_id}
          assessmentData={assessment_id}
        />
      )}

      {click && status === "pending" && (
        <PendingSpopup setPendingPopup1={setClick} />
      )}
    </>
  );
};

export default CompleteSTable;
